import get from 'lodash/get';
import { request } from '../../utils/axios';
import { getHeaders } from '../../utils/commonMethods';
import {
  ADD_MANAGED_USER_LOADING,
  ADD_MANAGED_USER_SUCCESS,
  ADD_MANAGED_USER_ERROR,
  GET_USER_DETAILS_LOADING,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_ERROR,
  EDIT_USER_PERMISSION_LOADING,
  EDIT_USER_PERMISSION_SUCCESS,
  EDIT_USER_PERMISSION_ERROR,
  EDIT_USER_DETAILS_LOADING,
  EDIT_USER_DETAILS_SUCCESS,
  EDIT_USER_DETAILS_ERROR,
  REMOVE_USER_LOADING,
  REMOVE_USER_SUCCESS,
  REMOVE_USER_ERROR,
  SET_CONFIRMATION_MODEL_VISIBILITY
} from './types';

const RESPONSE_DATA = 'response.data';

export function setConfirmationModelVisibility(payload) {
  return {
    type: SET_CONFIRMATION_MODEL_VISIBILITY,
    payload: payload
  };
}

function addManagedUserLoading(payload) {
  return {
    type: ADD_MANAGED_USER_LOADING,
    payload: payload
  };
}

function addManagedUserSuccess(managedUser) {
  return {
    type: ADD_MANAGED_USER_SUCCESS,
    payload: managedUser
  };
}
function addManagedUserError(error) {
  return {
    type: ADD_MANAGED_USER_ERROR,
    error
  };
}

function getUserDetailsLoading(payload) {
  return {
    type: GET_USER_DETAILS_LOADING,
    payload: payload
  };
}

function getUserDetailsSuccess(managedUser) {
  return {
    type: GET_USER_DETAILS_SUCCESS,
    payload: managedUser
  };
}
function getUserDetailsError(error) {
  return {
    type: GET_USER_DETAILS_ERROR,
    error
  };
}

function editUserPermissionLoading(payload) {
  return {
    type: EDIT_USER_PERMISSION_LOADING,
    payload: payload
  };
}

function editUserPermissionSuccess(editedPermission) {
  return {
    type: EDIT_USER_PERMISSION_SUCCESS,
    payload: editedPermission
  };
}
function editUserPermissionError(error) {
  return {
    type: EDIT_USER_PERMISSION_ERROR,
    error
  };
}

function editUserDetailsLoading(payload) {
  return {
    type: EDIT_USER_DETAILS_LOADING,
    payload: payload
  };
}

function editUserDetailsSuccess(editedUserDetails) {
  return {
    type: EDIT_USER_DETAILS_SUCCESS,
    payload: editedUserDetails
  };
}
function editUserDetailsError(error) {
  return {
    type: EDIT_USER_DETAILS_ERROR,
    error
  };
}

function removeUserLoading(payload) {
  return {
    type: REMOVE_USER_LOADING,
    payload: payload
  };
}

function removeUserSuccess(editedPermission) {
  return {
    type: REMOVE_USER_SUCCESS,
    payload: editedPermission
  };
}
function removeUserError(error) {
  return {
    type: REMOVE_USER_ERROR,
    error
  };
}

export const addManagedUser = (managedUserData, orgId) => {
  return (dispatch) => {
    dispatch(addManagedUserLoading(true));
    return request({
      method: 'post',
      url: `/v2/orgs/${orgId}/accounts/`,
      headers: getHeaders(),
      data: managedUserData
    })
      .then((res) => {
        if (res.error) {
          throw res.error;
        }
        dispatch(addManagedUserSuccess(res.data));
        return res;
      })
      .catch((error) => {
        dispatch(addManagedUserError(get(error, RESPONSE_DATA, {})));
        return error;
      });
  };
};

export const getUserDetails = (orgId) => {
  return (dispatch) => {
    dispatch(getUserDetailsLoading(true));
    return request({
      method: 'get',
      url: `/v2/orgs/${orgId}/accounts/`,
      headers: getHeaders()
    })
      .then((res) => {
        if (res.error) {
          throw res.error;
        }
        dispatch(getUserDetailsSuccess(res.data));
        return res;
      })
      .catch((error) => {
        dispatch(getUserDetailsError(get(error, RESPONSE_DATA, {})));
        return error;
      });
  };
};

export const getUserDetailByAccountId = (accountId) => (dispatch) => {
  dispatch(getUserDetailsLoading(true));
  return request({
    method: 'get',
    url: `/v2/accounts/${accountId}`,
    headers: getHeaders()
  })
    .then((response) => {
      if (response.error) {
        throw response.error;
      }
      dispatch(getUserDetailsSuccess(response.data));
      return response;
    })
    .catch((error) => {
      dispatch(getUserDetailsError(get(error, 'response.data', {})));
      return error;
    });
};

export const editUserPermission = (editedPermission, userId) => {
  return (dispatch) => {
    dispatch(editUserPermissionLoading(true));
    return request({
      method: 'post',
      url: `/v2/accounts/${userId}/authorities/updates`,
      headers: getHeaders(),
      data: editedPermission
    })
      .then((res) => {
        if (res.error) {
          throw res.error;
        }
        dispatch(editUserPermissionSuccess(res.data));
        return res;
      })
      .catch((error) => {
        dispatch(editUserPermissionError(get(error, RESPONSE_DATA, {})));
        return error;
      });
  };
};

export const editUserDetails = (userDetails, userId) => {
  return (dispatch) => {
    dispatch(editUserDetailsLoading(true));
    return request({
      method: 'put',
      url: `/v2/accounts/${userId}`,
      headers: getHeaders(),
      data: userDetails
    })
      .then((res) => {
        if (res.error) {
          throw res.error;
        }
        dispatch(editUserDetailsSuccess(res.data));
        return res;
      })
      .catch((error) => {
        dispatch(editUserDetailsError(get(error, RESPONSE_DATA, {})));
        return error;
      });
  };
};

export const removeUserFromOrg = (user, orgId) => async (dispatch) => {
  const { id: userId, type: userType, authorities } = user;
  dispatch(removeUserLoading(true));

  const orgAuthorities = authorities.filter(
    (authority) => authority.context === 'ORGANIZATION' && authority.id === orgId
  );

  let params = {
    method: 'post',
    url: `/v2/accounts/${userId}/authorities/updates`,
    data: {
      updates: [
        {
          operation: 'remove',
          authorities: orgAuthorities
        }
      ]
    }
  };
  if (userType === 'MANAGED') {
    params = {
      method: 'delete',
      url: `/v2/accounts/${userId}`
    };
  }

  try {
    const response = await request({
      ...params,
      headers: getHeaders()
    });

    if (response.error) {
      throw response.error;
    }
    dispatch(removeUserSuccess({ data: response.data, userId: userId }));
    return response;
  } catch (error) {
    dispatch(removeUserError(get(error, RESPONSE_DATA, {})));
    return error;
  }
};
